import {
  AfterContentInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormularGroupTabContentComponent } from "../tab-content.interface";
import { IFormOptionItem } from "src/app/common-components/form-controls/form-option/option.component";
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { CommonKeys } from "../../../formular-model/common/enums";
import {
  FormularGroupWartungen,
  WartungsKategorie,
} from "../../../formular-model/formular-groups/interfaces/FormularGroupWartungen";
import { FormularBerichtText } from "../../../formular-model/formular-groups/interfaces/FormularBericht";

interface IWartungFormOptionItem extends IFormOptionItem {
  char: string;
  bgColor: string | null;
  fontColor: string | null;
}

@Component({
  selector: "tab-formular-group-wartungen",
  templateUrl: "./wartungen.component.html",
  styleUrls: ["./wartungen.component.scss"],
  standalone: false,
})
export class FormularGroupTabWartungenComponent
  extends FormularGroupTabContentComponent<FormularGroupWartungen>
  implements OnInit, AfterContentInit
{
  override formularGroupDataKey = "Wartungen";

  @ViewChild("wrapper", { static: true })
  public wrapper!: ElementRef<HTMLDivElement>;

  public wartungOptions: IWartungFormOptionItem[] = [];

  get internalValues(): WartungsKategorie[] {
    return this.__dataInternal[this.formularGroupDataKey][CommonKeys.Values];
  }

  get wartungenCtlArray(): FormArray {
    return this.form.get(this.formularGroupDataKey) as FormArray;
  }

  get berichteCtlArray(): FormArray {
    return this.form.get("Berichte") as FormArray;
  }

  getControlByIndex(i: number, j: number): FormControl {
    return (this.wartungenCtlArray.controls[i] as FormArray).controls[
      j
    ] as FormControl;
  }

  getKategorieCtlArray(index: number): FormArray {
    return this.wartungenCtlArray.at(index) as FormArray;
  }

  getBerichtCtlGroup(i: number): FormGroup {
    return this.berichteCtlArray.controls[i] as FormGroup;
  }

  getBerichtCtl(i: number, name: string): FormControl {
    return this.getBerichtCtlGroup(i).get(name) as FormControl;
  }

  getKategorieByIndex(i: number) {
    return this.internalValues[i];
  }

  getElementByIndex(i: number, j: number) {
    return this.getKategorieByIndex(i)["Elemente"][CommonKeys.Values][j];
  }

  hasBerichte(kategorie: WartungsKategorie): boolean {
    if (kategorie["Berichte"] !== null)
      return this.getKategorieBerichte(kategorie).length > 0;
    return false;
  }

  getKategorieBerichte(kategorie: WartungsKategorie): FormularBerichtText[] {
    return kategorie["Berichte"]["Berichte"][CommonKeys.Values];
  }

  ngOnInit(): void {
    this.__dataInternal = { ...this.data };

    this.form = new FormGroup({
      [this.formularGroupDataKey]: new FormArray([]),
      Berichte: new FormArray([]),
    });

    this.data["WartungsStates"].forEach((state) => {
      let bg = state["BackColorHex"];
      let fg = state["FontColorHex"];

      if (fg && !bg) {
        bg = fg;
        fg = "#000";
      }

      this.wartungOptions.push({
        label: state["Label"],
        value: state["Value"],
        char: this.getCharFromHex(state["SymbolCharHex"]),
        bgColor: bg,
        fontColor: fg,
      });
    });
  }

  ngAfterContentInit(): void {
    this.data[this.formularGroupDataKey][CommonKeys.Values].forEach(
      (kategorie: WartungsKategorie) => {
        const kategorieCtlArray = new FormArray([]);
        this.wartungenCtlArray.push(kategorieCtlArray);

        kategorie["Elemente"][CommonKeys.Values].forEach((element) => {
          kategorieCtlArray.push(new FormControl(element["State"]));
        });

        const kategorieBerichteCtlGroup = new FormGroup({});
        this.berichteCtlArray.push(kategorieBerichteCtlGroup);

        if (this.hasBerichte(kategorie))
          this.getKategorieBerichte(kategorie).forEach((bericht, i) => {
            kategorieBerichteCtlGroup.addControl(
              `bericht-${i}`,
              new FormControl(bericht["Value"]),
            );
          });
      },
    );
  }

  getCharFromHex(charString: string): string {
    if (!charString) return "";

    let result = "";
    const decimal = parseInt(charString, 16);

    if (!decimal) {
      console.error(
        "Invalid Unicode code point:",
        decimal,
        "from hex:",
        charString,
      );

      return "";
    }

    try {
      result = String.fromCodePoint(decimal);
    } catch (_) {
      console.error(
        "Invalid Unicode code point:",
        decimal,
        "from hex:",
        charString,
      );
      result = "";
    }

    return result;
  }

  reconstructData() {
    for (let i = 0; i < this.internalValues.length; i++) {
      const kategorie: WartungsKategorie = this.getKategorieByIndex(i);

      for (
        let ki = 0;
        ki < kategorie["Elemente"][CommonKeys.Values].length;
        ki++
      ) {
        const element = kategorie["Elemente"][CommonKeys.Values][ki];
        element["State"] = this.getControlByIndex(i, ki).value;
      }

      if (this.hasBerichte(kategorie)) {
        this.getKategorieBerichte(kategorie).forEach((b, bi) => {
          b["Value"] = this.getBerichtCtl(i, "bericht-" + bi).value;
        });
      }
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { MaterialActionNames, WartungsStates, FormularID, ...data } =
      this.__dataInternal;
    return data;
  }
}
